export default __webpack_public_path__ + "static/media/2_E2.10eb0341.jpg";